import { Camera, FileCheck2, CheckCircle2, PhoneCall } from "lucide-react";
import { Eyebrow, PHONE, Reveal } from "./shared";

const STEPS = [
  {
    num: "01",
    icon: Camera,
    title: "Snap & Send",
    body: `Text ${PHONE} or use the form below. Address, a tape-measure width across the flare — best guess is fine, I adjust on arrival if it's off — plus a photo of the stump and any gate notes. Two minutes, tops.`,
  },
  {
    num: "02",
    icon: FileCheck2,
    title: "Locked Friday Quote",
    body: "I text back a firm, flat price — usually within a few hours. No site visit, no upsell, no 'starting at' games. Approve it and you're on the dispatch list.",
  },
  {
    num: "03",
    icon: PhoneCall,
    title: "I Call 811 For You",
    body: "The moment your quote is locked, I file an 811 utility locate on your property — the law before any grinding. Crews mark underground lines within about 3 days, free to you. Approve late in the week and marking may run long — your job simply rolls to the following Friday. Zero effort on your end.",
  },
  {
    num: "04",
    icon: CheckCircle2,
    title: "Friday Grind + Proof",
    body: "Leave the gate unlocked; that's the whole job for you. I grind 4–8″ below grade, text you a photo of flat ground, and send a simple payment link. Done before sunset.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" data-testid="how-it-works-section" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-20 sm:px-8 sm:py-28">
      <div>
        <div>
          <Reveal>
            <Eyebrow>03 — How It Works</Eyebrow>
            <h2 className="mt-4 font-display text-2xl font-black uppercase leading-tight tracking-tight text-bone sm:text-3xl lg:text-4xl">
              The 4-step<br />contactless protocol.
            </h2>
          </Reveal>

          <div className="mt-10">
            {STEPS.map((s, i) => (
              <Reveal key={s.num} delay={i * 0.1}>
                <div data-testid={`how-step-${s.num}`} className="group flex gap-6 border-t border-stone-800 py-8 last:border-b">
                  <span className="font-display text-4xl font-black leading-none text-stone-800 transition-colors duration-200 group-hover:text-amber-500 sm:text-5xl">
                    {s.num}
                  </span>
                  <div>
                    <h3 className="flex items-center gap-3 font-display text-xl font-bold uppercase tracking-normal text-bone sm:text-2xl">
                      <s.icon className="h-5 w-5 text-amber-500" strokeWidth={1.5} />
                      {s.title}
                    </h3>
                    <p className="mt-3 max-w-lg text-sm leading-relaxed text-stone-400 sm:text-base">
                      {s.body}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
